document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.sentence-case').forEach(el => {
    const text = el.textContent.trim();

    if (!text) return;

    const firstChar = text.charAt(0);
    const secondChar = text.charAt(1);
    const rest = text.slice(2);

    let updated = '';

    if (!isNaN(firstChar) && secondChar) {
      // First is number, capitalize second
      updated = firstChar + secondChar.toUpperCase() + rest.toLowerCase();
    } else {
      // Normal sentence case: keep first, lowercase the rest
      updated = firstChar + text.slice(1).toLowerCase();
    }

    el.textContent = updated;
  });
}); 